import { render, staticRenderFns } from "./quota.vue?vue&type=template&id=0a877d22&scoped=true"
import script from "./quota.vue?vue&type=script&lang=jsx"
export * from "./quota.vue?vue&type=script&lang=jsx"
import style0 from "./quota.vue?vue&type=style&index=0&id=0a877d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a877d22",
  null
  
)

export default component.exports